import React, {useState} from "react";
import {Switch} from "@material-ui/core";
import styled from "styled-components";

import colors from "../../helpers/Colors";

export function TickSwitch(props) {
  const [isChecked, setIsChecked] = useState(props.isSwitchChecked);
  return (<AndroidTypeSwitch
      isChecked={isChecked}
      checked={isChecked}
      onChange={() => {
        props.onSwitchChange(!isChecked);
        setIsChecked(!isChecked)
      }}
      disabled={props.isDisabled}
      inputProps={{'aria-label': 'controlled'}}/>);
}

const AndroidTypeSwitch = styled(Switch)(({isChecked}) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
      backgroundImage: isChecked
          ? `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><path fill="white" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`
          : null,
      left: 16,
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 13,
    height: 12,
    margin: isChecked ? '3.5px' : '3.7px',
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: colors.white
  },
  "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
    backgroundColor: colors.grubtechBlue,
    opacity: 1,
  }
}));